module.exports = __webpack_public_path__ + "static/media/home-banner-1.c8199da7.png";